import {
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/Decoding.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonDecoderClass;
function JsonDecoder() {
  if (JsonDecoderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'JsonDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    JsonDecoderClass = $;
  }
  return JsonDecoderClass;
}
//region block: exports
export {
  JsonDecoder as JsonDecoder1rijst5ne6qla,
};
//endregion

//# sourceMappingURL=JsonDecoder.mjs.map
